export default __webpack_public_path__ + "static/Narcotic-29971d0c8d30d2e5349166711f414265.png";